import React from "react";
import Link from "next/link";
import { useDisclosure } from "@mantine/hooks";
import GetQuoteModal from "@components/Modal/GetQuoteModal";

function DiscountAlertText({ content }) {
  // const [opened, { open, close }] = useDisclosure(false);

  // const quoteModalHandler = () => {
  //   open();
  // }

  return (
    <div className="mx-auto max-w-[1280px] w-full">
      <div className="flex flex-row gap-6 border  border-gray-300 rounded-lg md:px-8 px-0 md:pt-0 pt-5 pb-5 pr-5 items-center md:bg-gradient-to-r md:from-nivabupa-blue-ethinosPlanRecommendation bg-nivabupa-blue-ethinosPlanRecommendation md:to-white">
        <div className="lg:w-[15%] w-[40%]">
          <img
            src="/aem-to-react/category-page/Family-with-donut.png"
            alt="Discount alert"
            loading="lazy"
            className="w-full"
          />
        </div>
        <div className="lg:w-[85%] w-[60%] flex lg:flex-row flex-col items-center">
          <div className="lg:w-[70%] md:pr-10 pr-0 w-full text-sm text-white md:text-left text-center">
            <h3 className="lg:text-[1.5rem] text-xl font-semibold mb-3">
              {content?.title || ""}
            </h3>
            <p className="lg:text-wrap ">{content?.description || ""}</p>
          </div>
          <div className="lg:w-[30%] w-full text-center lg:py-0 py-1">
            {/* <Link
              target="_blank"
              href={content?.cta_button_url || "/"}
              className="bg-nivabupa-ethinosHomeOrange mx-3 px-4 lg:px-5 py-1 lg:py-2 shadow-md text-white font-semibold border-2 border-white rounded-xl text-base"
            > */}
            <div className="bg-nivabupa-ethinosHomeOrange mx-3 px-4 lg:px-5 py-1 lg:py-2 shadow-md text-white font-semibold border-2 border-white rounded-xl text-base">
              {content?.cta_button_text || "Get Quote"}
            </div>
            {/* </Link> */}
          </div>
        </div>
      </div>
      {/* <GetQuoteModal opened={opened} close={close} open={open} isds={isds}/> */}
    </div>
  );
}

export default DiscountAlertText;
